import React from 'react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  DialogClose,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { AlertCircle } from 'lucide-react'
import { InlineDocumentViewer } from '@/features/membership/documents/components/InlineDocumentViewer'

interface FileViewerDialogProps {
  open: boolean
  onClose: () => void
  fileUrl?: string
  fileName?: string
  description?: string
}

export const FileViewerDialog: React.FC<FileViewerDialogProps> = ({
  open,
  onClose,
  fileUrl,
  fileName,
  description,
}) => {
  const dialogTitle = fileName || 'File Viewer'

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="sm:max-w-xl">
        <DialogHeader>
          <DialogTitle>{dialogTitle}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        {fileUrl ? (
          <div className="space-y-3">
            <Button asChild variant="outline" className="w-full">
              <a href={fileUrl} target="_blank" rel="noreferrer">
                Open file in new tab
              </a>
            </Button>
            <InlineDocumentViewer
              url={fileUrl}
              title={dialogTitle}
              className="h-96 w-full"
            />
          </div>
        ) : (
          <div className="space-y-2 rounded-md border border-dashed border-muted p-6 text-center text-sm text-muted-foreground">
            <AlertCircle className="mx-auto h-10 w-10" />
            <p>No file was provided.</p>
          </div>
        )}
        <DialogFooter className="mt-6">
          <DialogClose asChild>
            <Button variant="outline" onClick={onClose}>
              Close
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default FileViewerDialog
